import {Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges} from '@angular/core';
@Component({
  selector: 'app-select2',
  templateUrl: './select2.component.html',
  styleUrls: ['./select2.component.scss']
})
export class Select2Component implements OnInit, OnChanges {
    @Input() list: any[];
    @Input() set oneonly (res){
      this.only = res ? true : false;
      this.checkedList = [];
      this.list.forEach((item) => {
        item.checked = false;
      });
      this.currentSelected = [];
      this.shareCheckedlist();
      this.shareIndividualStatus();
    };
    @Input() placeholder: string;
    @Input() inclass: string;
    @Input() required = true;
    @Output() changedList? = new EventEmitter();
    @Output() shareIndividualCheckedList? = new EventEmitter();

    checkedList: any[];
    currentSelected: {};
    listText: string;
    showDropDown: boolean;
    all: boolean;

    only: boolean = false;
    constructor() {
        this.checkedList = [];
    }

    /**
     * @Description:
     */
    ngOnInit() { }

    toggleSelectAll(checked) {
      this.checkedList = [];
      if (checked) {
        this.list.forEach((value) => {
          value.checked = true;
          this.checkedList.push(value);
        });
        this.listText = this.checkedList.map(e => e.value).join(', ');
      } else {
        this.list.forEach((value) => {
          value.checked = false;
        });
        this.listText = '';
      }

      this.shareCheckedlist();
      this.shareIndividualStatus();

    }

    /**
     * @Description:
     * @param {Boolean} checked
     * @param {Any} obj
     */
    getSelectedValue(checked: Boolean, obj: any) {
        obj.checked = checked;
        if(!this.only) {
          if (checked) {
              this.checkedList.push(obj);
              this.listText = this.checkedList.map(e => e.value).join(', ');
          } else {
              const index = this.checkedList.indexOf(obj);
              this.checkedList.splice(index, 1 );
              this.listText = this.checkedList.map(e => e.value).join(', ');
          }
        }else{
          for (let i = 0; i < this.list.length; i++) {
            this.list[i].checked = this.list[i].id==obj.id ? true : false;
          }
          this.checkedList = [obj];
          this.listText = this.checkedList.map(e => e.value).join(', ');
        }

        this.currentSelected = obj;
        this.shareCheckedlist();
        this.shareIndividualStatus();
    }

    /**
     * this clear selected items
     */
    clear() {
        this.checkedList = [];
        this.changedList.emit(this.checkedList);
        this.list.forEach((item) => {
            item.checked = false;
        });
        this.all = false;
    }

    /**
     * @Description:
     */
    shareCheckedlist() {
        this.changedList.emit(this.checkedList);
    }

    /**
     * @Description:
     */
    shareIndividualStatus() {
        this.shareIndividualCheckedList.emit(this.currentSelected);
    }

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['list']) {
        this.list = changes['list'].currentValue;
        this.proceList();
      }
    }

    /**
     * @Description:
     */
    proceList() {
        this.checkedList = [];
        if (this.list) {
          if (this.list.length > 0) {
              this.list.forEach((row) => {
                if (row.checked) {
                      this.checkedList.push(row);
                      this.listText = this.checkedList.map(e => e.value).join(', ');
                  }
              });
          }
        }
      }
}




// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/select2/select2.component.ts